import React, { Component, Fragment } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class Datatable extends Component {
  render() {
    const { myData, history } = this.props;
    const rows = myData || [];

    return (
      <Fragment>
        <div className="iv-table-wrap">
          <table className="table iv-table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Designation</th>
                <th scope="col">Address</th>
                <th scope="col">Status</th>
                <th scope="col" className="iv-col-action">Inspect</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan={5} className="iv-empty">
                    No employees yet.
                  </td>
                </tr>
              ) : (
                rows.map((employee, i) => (
                  <tr key={i}>
                    <td>{employee.name}</td>
                    <td>{employee.designation}</td>
                    <td>{employee.address}</td>
                    <td>
                      <span
                        className={`iv-badge ${
                          employee.status === "Active" ? "iv-badge--active" : "iv-badge--inactive"
                        }`}
                      >
                        {employee.status}
                      </span>
                    </td>
                    <td className="iv-col-action">
                      <button
                        type="button"
                        className="iv-icon-btn"
                        onClick={() => {
                          history.push(`/expense/invest/${employee.name}`);
                        }}
                      >
                        <i className="fa fa-eye"></i>
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        <ToastContainer />
      </Fragment>
    );
  }
}

export default Datatable;
